import React, { FC } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";

import { Input, Label, Button } from "../../common";
import { SUPPORT_EMAIL } from "../../../constants";
import { VerifyProps } from "../../../types";

type Inputs = {
  code?: string;
};

export const VerifyForm: FC<VerifyProps> = ({ action }) => {
  const {
    handleSubmit,
    control,
    formState: { isDirty, isValid },
  } = useForm<Inputs>({
    defaultValues: {
      code: "",
    },
  });

  const onSubmit: SubmitHandler<Inputs> = (data: Inputs) =>
    action && action(data);

  return (
    <div className="">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Label label="6-digit authentication code" className="mb-12">
          <Controller
            name="code"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input
                autoFocus
                type="text"
                minLength="6"
                maxLength="6"
                {...field}
              />
            )}
          />
        </Label>

        <Button
          type="submit"
          variant={Button.variant.PRIMARY}
          className="w-full"
          disabled={!isDirty || !isValid}
        >
          Verify
        </Button>

        <div className="text-sm	text-gray-300 text-center mt-6">
          Contact&nbsp;
          <a href={`mailto:${SUPPORT_EMAIL}`} className="theme-link">
            Customer Support
          </a>
          &nbsp;for assistance
        </div>
      </form>
    </div>
  );
};
